// extracted by mini-css-extract-plugin
export default {"PFS404Page":"PFS404Page_PFS404Page__DkAcY","TextContainer":"PFS404Page_TextContainer__VaFYH","IconContainer":"PFS404Page_IconContainer__X8sMQ"};